import React from "react";
import { Opportunity } from "../../api/types";
import { Badge } from "@/components/Badge/Badge";

interface OpportunityListProps {
  opportunities: Opportunity[];
  selectedIndex: number;
  onSelect: (index: number) => void;
}

function OpportunityList({
  opportunities,
  selectedIndex,
  onSelect,
}: OpportunityListProps) {
  return (
    <div className="overflow-y-auto h-full">
      {opportunities.map((opportunity, index) => {
        const isSelected = index === selectedIndex;
        const isUnlinked = opportunity.opportunityId === null;
        const companyName =
          opportunity.company || opportunity.name || "No Opportunity Linked";
        const eventCount = opportunity.events.length;

        return (
          <div
            className={[
              "cursor-pointer px-4 py-3 border-b border-gray-200 dark:border-slate-700 transition-colors",
              isSelected
                ? "bg-slate-100 dark:bg-slate-700 border-l-2 border-l-blue-500"
                : "bg-white dark:bg-slate-800 hover:bg-gray-50 dark:hover:bg-slate-700/50",
            ].join(" ")}
            key={index}
            onClick={() => onSelect(index)}
          >
            <p className="text-sm text-gray-900 dark:text-white font-normal truncate">
              {isUnlinked ? "No Opportunity Linked" : companyName}
            </p>
            <div className="mt-1 flex items-center gap-2">
              {!isUnlinked && opportunity.stageName && (
                <Badge variant="grey">{opportunity.stageName}</Badge>
              )}
              <span className="text-xs text-gray-500 dark:text-gray-400">
                {eventCount} {eventCount === 1 ? "event" : "events"}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export { OpportunityList };
export default OpportunityList;
